var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-share"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTip),expression:"showTip"}],staticClass:"v-share__tip"},[_c('div',{staticClass:"v-share__tip--btn",on:{"click":_vm.handleTipClose}},[_vm._v("知道了")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }